import React, { type JSX, type PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

interface SectionProps {
  title?: string | JSX.Element;
  subtitle?: string | JSX.Element;
  className?: string;
  contentClassName?: string;
  prepend?: JSX.Element;
  append?: JSX.Element;
}

export default function HomepageSection({ title, subtitle, className, contentClassName, children, prepend, append }: PropsWithChildren<SectionProps>) {
  return (
    <section className={className}>
      <div className="flex">
        {append && <div className="flex w-[56px] shrink-0 items-center justify-center self-stretch">{append}</div>}
        <div className="flex flex-1 flex-col gap-1 md:gap-2">
          {typeof title === "string" ? (
            <h3 className="font-mono text-base font-bold uppercase leading-5 tracking-normal text-neutral-900 md:text-xl md:leading-6">{title}</h3>
          ) : (
            title
          )}
          {typeof subtitle === "string" ? (
            <div className={twMerge("font-mono text-sm uppercase tracking-[1px] md:text-base", title !== undefined ? "text-neutral-700" : "text-neutral-900")}>{subtitle}</div>
          ) : (
            subtitle
          )}
        </div>

        {prepend && <div className="shrink-0">{prepend}</div>}
      </div>

      <div className={twMerge("mt-5 md:mt-10", contentClassName)}>{children}</div>
    </section>
  );
}
